import { makeAutoObservable } from "mobx";

interface PayerObject {
  org_name?: string;
  org_id?: string;
  invoice_id?: string;
  payment_id?: string;
  consumer_id?: string;
  consent_id?: string;
  entity_number?: string;
}

class Payer {
  org_name?: string;
  org_id?: string;
  invoice_id?: string;
  payment_id?: string;
  consumer_id?: string;
  consent_id?: string;
  entity_number?: string;

  constructor() {
    makeAutoObservable(this);
  }

  setPayer(payer_: PayerObject): void {
    this.org_name = payer_.org_name;
    this.org_id = payer_.org_id;
    this.invoice_id = payer_.invoice_id;
    this.payment_id = payer_.payment_id;
    this.consumer_id = payer_.consumer_id;
    this.consent_id = payer_.consent_id;
    this.entity_number = payer_.entity_number;
  }
}

export default Payer;
